module.exports = __webpack_public_path__ + "img/mark_body_male_image.fd97d63c.svg";